<template>
  <div>
    <el-dialog :visible.sync="showDeleteDialog">
      <div v-if="editedValues.usage_count !== 0">
        <div><em>This image is used {{editedValues.usage_count}} times.
          You can't delete the image until you remove them from the report(s)
        that are referencing them:</em>
        <ul>
          <li v-for="report_title in editedValues.report_titles">{{report_title}}</li>
        </ul>
        </div>

      </div>
      <div v-else>
        <div style="margin-bottom:30px;">
        Are you sure you want to delete {{editedValues.name}}?
        </div>
        <div style="margin-bottom:30px;">
        <el-button v-on:click="do_delete()" type="danger">Yes, really delete {{editedValues.name}}.</el-button>
        <el-button v-on:click="cancel_delete()" type="success">Oops. Don't delete..</el-button>
        </div>
      </div>

    </el-dialog>
    <el-dialog :visible.sync="showDialog">
      <FormManager
          :initialFormValues="editedValues"
          prettyEndPoint="/images/pretty"
          :events="events"
          @save="save"
          @cancel="cancel"
      />
    </el-dialog>
    <el-row>
      <el-col :span="3">...</el-col>
      <el-col :span="15">
      <div style="margin-bottom: 20px;">
        <h2 style="display:inline; ">Images</h2>
        <el-button style="float:right;" icon="el-icon-plus" @click="add"></el-button>
      </div>

      <el-table
          :data="images">
        <el-table-column
            v-for="column in columnDefinitions"
            v-bind:label = column.label
            v-bind:prop = column.prop
            v-bind:width = column.width
        >
          <template slot-scope="scope">
            <div v-if="column.prop==='public_url'">
              <img width="100%" :src="scope.row['public_url']" />
            </div>
            <div v-else-if="column.label==='Actions'">
              <el-button @click="edit(scope.row)" icon="el-icon-edit" style="margin-left:20px;"></el-button>
              <el-button @click="delete_dialog(scope.row)" icon="el-icon-delete" style=""></el-button>
            </div>
            <div v-else-if="column.label==='Usages'">
              {{scope.row[column.prop]}}
              <el-popover
                  placement="top-start"
                  title="Usages of the images in reports"
                  width="500"
                  trigger="hover"
              >
                <ul>
                  <li v-for="report_title in scope.row['report_titles']">{{report_title}}</li>
                </ul>
                <i class="el-icon-info" slot="reference"></i>
              </el-popover>
            </div>
            <div v-else>
                {{scope.row[column.prop]}}
            </div>
          </template>
        </el-table-column>
      </el-table>
      </el-col>
    </el-row>

  </div>
</template>

<script>
export default {
  name: "ImageList",
  props: ['extent_id'],
  mounted() {
    this.editedValues = this.defaultEditedValues
    this.get()
  },
  data() {
    return {
      waiting_on_data: false,
      ready: false,
      images: [],
      showDialog: false,
      showDeleteDialog: false,
      editedValues: null,
      defaultEditedValues: {
        name: '',
        temp_filename: '',
      },
      columnDefinitions: [
        {
          label: 'Name',
          prop: 'name',
          width: "150px"
        },
        {
          label: 'Image',
          prop: 'public_url',
          width: "200px"
        },
        {
          label: 'Actions',
          prop: 'user_id',
          width: "200px"
        },
        {
          label: 'Usages',
          prop: 'usage_count',
          width: "100px"
        }
      ],
      events: {
        save: {
          label: "Save" ,
          event: "save"
        },
        cancel: {
          label: "Cancel",
          event: "cancel"
        }
      },
    }
  },
  methods: {
    add() {
      this.showDialog = true
      this.editedValues = this.defaultEditedValues
    },
    edit(row) {
      this.showDialog = true
      this.editedValues = row
    },
    delete_dialog(row) {
      this.editedValues = row
        this.showDeleteDialog = true
    },
    do_delete() {
      console.log('deleting' + this.editedValues.name)
      axios.delete('/images/' + this.extent_id + '/' + this.editedValues.id, {
      }).then(response => {
        console.log('finished deleting image')
        this.get()
        this.showDeleteDialog = false
        this.editedValues = this.defaultEditedValues
      }).catch(error => {
        console.log('Could not delete image')
        console.log(error.response)
        this.showDeleteDialog = false
      });
    },
    cancel_delete() {
      this.showDeleteDialog = false
    },
    save(value) {
      this.editedValues = value
      axios.post('/images/save/' + this.extent_id, {
        values: this.editedValues
      }).then(response => {
        console.log('finished saving image')
        this.get()
        this.showDialog = false
      }).catch(error => {
        console.log('Could not save image')
        console.log(error.response)
        this.showDialog = false
      });
    },
    cancel() {

    },
    get() {
      this.waiting_on_data = true
      axios.get('/images/list_all/' + this.extent_id)
          .then(response => {
            this.images = response.data
            console.log('got images')
            this.ready = true
            this.waiting_on_data = false
          }).catch(error => {
            this.ready = false
            this.annotations = []
            console.log('did not get images')
            console.log(error.response)
            this.waiting_on_data = false
          })
      //
    },
  }
}
</script>

<style scoped>

</style>